// extracted by mini-css-extract-plugin
export default {"container":"OverlapTable_container__hvJE0","addImg":"OverlapTable_addImg__liPjt"};